import { React, useState, useEffect } from "react";

import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import OutsideClickHandler from "react-outside-click-handler";

import { DeleteCardModule } from "../../Modal/DeleteCard";
import { NoAlertComponent } from "../../Components/NoAlert";
import { useDispatch } from "react-redux";

import chart from "../../Assets/img/icons/chart__icon.svg";
import chart_open from "../../Assets/img/icons/chart__icon__open.svg";

import {
  ApiDeletePartnerGuardItem,
  ApiPartnerGuardAlertUpdate,
} from "../../Api";

import { DELETE_PARTNER_GUARD_SUCCESS } from "../../Reducer/DeletePartnerGuardReducer";

import { CounterpartyRiskChart } from "../../Modal/CounterpartyRiskChart";

export function PartnerGuardItem({ element, reloadListCallback }) {
  const dispatch = useDispatch();

  const [alertvalue, setAlertValue] = useState();

  const [openProgress, setOpenProgress] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [showAlert, setShowAlert] = useState(false);

  const [openChart, setOpenChart] = useState(false);

  const coldprops = {
    percent: Math.round(element?.partnersGuardId?.defaultRisk), // is require
    colorSlice: "#4DC7B5",
    fontColor: "#4DC7B5",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const hotprops = {
    percent: Math.round(element?.partnersGuardId?.defaultRisk), // is require
    colorSlice: "#EFB661",
    fontColor: "#EFB661",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const riskprops = {
    percent: Math.round(element?.partnersGuardId?.defaultRisk), // is require
    colorSlice: "#F27281",
    fontColor: "#F27281",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const renderClassName = (element) => {
    if (
      element?.partnersGuardId?.defaultRisk <= 100 &&
      element?.partnersGuardId?.defaultRisk >= 80
    ) {
      return {
        className: "card cold nft",
        props: coldprops,
      };
    } else if (
      element?.partnersGuardId?.defaultRisk < 80 &&
      element?.partnersGuardId?.defaultRisk >= 60
    ) {
      return {
        className: "card hold nft",
        props: hotprops,
      };
    } else if (element?.partnersGuardId?.defaultRisk < 60) {
      return {
        className: "card risky nft",
        props: riskprops,
      };
    } else if (element?.partnersGuardId?.defaultRisk === null || 0) {
      return {
        className: "card card__product__white nft",
      };
    }
  };

  useEffect(() => {
    setAlertValue(+element.alert);
  }, [element]);

  const handleChange = (value, e) => {
    // e.preventDefault()
    setAlertValue(value);
  };

  const alertOnChangeComplete = (value) => {
    ApiPartnerGuardAlertUpdate(element.id, +alertvalue)
      .then((result) => {})
      .catch((error) => {});
  };

  return (
    <>
      <div className={renderClassName(element)?.className}>
        <div className="card__header">
          <div className="row light_defi_row">
            <div
              className="chart__open__btn"
              onClick={() => {
                setOpenChart(!openChart);
              }}
            >
              {openChart ? (
                <img src={chart} alt="" className="chart__opened__btn__icon" />
              ) : (
                <img
                  src={chart_open}
                  alt=""
                  className="chart__open__btn__icon"
                />
              )}
            </div>

            <h2 className="card__title ntf_card_title">
              {element?.partnersGuardId?.name}
            </h2>
            <div
              className="close__card__content"
              onClick={() => {
                setOpenDeleteModal(!openDeleteModal);
              }}
            >
              <span className="card__close">
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
        <div className="card__nft__wrapper">
          <img
            src={element?.partnersGuardId?.image}
            alt="nft1"
            className="card__nft__img partner_img_item"
          />
        </div>

        <div className="card__risk">
          <h3 className="card__risk__title">Counterparty Risk</h3>

          <div
            className={
              "card__risk__alert" +
              " " +
              (openProgress ? "active" : "card__risk__alert")
            }
            onClick={(event) => {
              if (openProgress) {
                alertOnChangeComplete();
              }
              setOpenProgress(!openProgress);
              //  event.stopPropagation()
            }}
          >
            <p className="card__risk__alert__title">Alert</p>
            <p
              className={
                "card__risk__alert__number" +
                " " +
                (alertvalue === 0 || null
                  ? "card__risk__alert__not_number"
                  : "card__risk__alert__number")
              }
            >
              {alertvalue === null || 0 ? 0 : alertvalue}
            </p>
          </div>
          <div className="card__risk__chart">
            <CircularProgressBar {...renderClassName(element)?.props}>
              <div className="card__round__shadow"></div>
              <div className="card__risk__chart__min__wrapper">
                <p className="card__risk__chart__number">
                  {renderClassName(element)?.props?.percent}
                </p>
                <p className="card__risk__chart__number__of">of 100</p>
              </div>
            </CircularProgressBar>
          </div>
          <div
            className="card__risk__info"
            onClick={() => {
              setTimeout(() => {
                setShowAlert(true);
              });
              setTimeout(() => {
                setShowAlert(false);
              }, 2000);
            }}
          >
            <i className="icon-info-icon"></i>
          </div>

          <div>
            {openProgress ? (
              <div
                className={
                  "card__risk__range active card__slider" +
                  " " +
                  (alertvalue === 0 || null
                    ? "card__slider_not_value"
                    : "card__risk__range active card__slider")
                }
              >
                <Slider
                  min={0}
                  max={100}
                  value={alertvalue === null || 0 ? 0 : alertvalue}
                  orientation="vertical"
                  onChange={handleChange}
                  tooltip={false}
                  onChangeComplete={alertOnChangeComplete}
                  step={1}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="card__risk__range"></div>
        </div>
      </div>

      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenChart(false);
        }}
      >
        {openChart ? (
          <CounterpartyRiskChart
            element={element}
            closeModal={() => {
              setOpenChart(false);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>

      <OutsideClickHandler
        onOutsideClick={(event) => {
          setShowAlert(false);
        }}
      >
        {showAlert ? <NoAlertComponent top={60} title={"No Alerts."} /> : ""}
      </OutsideClickHandler>

      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenDeleteModal(false);
        }}
      >
        {openDeleteModal ? (
          <DeleteCardModule
            title="You are going to delete the Counterparty"
            text="This Counterparty will be deleted, but can be restored from the Recycle Bin."
            element={element}
            deleteItem={(id) => {
              ApiDeletePartnerGuardItem(id)
                .then((result) => {
                  dispatch({
                    type: DELETE_PARTNER_GUARD_SUCCESS,
                  });
                  setOpenDeleteModal(false);
                  reloadListCallback();
                })
                .catch((error) => {});
            }}
            cancel={(event) => {
              setOpenDeleteModal(event);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
    </>
  );
}
